import { handleShowModal } from 'components/global/_helpers/global.helpers';
import ContextMenu from 'components/global/ContextMenu';
import { $view } from 'signals/global.signals';
import { formatMoneyShorthand } from 'utils/formatMoney';

const getStageBadge = (stage) => {
  switch (stage) {
    case 'Pre-seed':
      return <span className="badge bg-info text-dark">Pre-Seed</span>;
    case 'seed':
      return <span className="badge bg-success">Seed</span>;
    case 'series_a':
      return <span className="badge bg-primary">Series A</span>;
    case 'series_b':
      return <span className="badge bg-info text-dark">Series B</span>;
    default:
      return <span className="badge bg-secondary">{stage}</span>;
  }
};

const InvestorPortfolioListRow = ({ data }) => data.map((item) => ({
  ...item,
  id: item.id,
  companyName: item.companyName,
  team: $view.value.teamOptions?.find((team) => team.value === item.teamId)?.label,
  investmentStage: getStageBadge(item.investmentStage),
  currentValuation: formatMoneyShorthand(item.currentValuation),
  holdingsPct: `${item.holdingsPct}%`,
  holdingsValue: formatMoneyShorthand(item.holdingsValue),
  arr: formatMoneyShorthand(item.arr),
  Actions: (
    <ContextMenu
      menuItems={[
        { label: 'Edit', onClick: () => handleShowModal('investor-portfolio-edit', item) },
        { label: 'Delete', onClick: () => handleShowModal('investor-portfolio-delete', item) },
      ]}
    />
  ),

}));

export default InvestorPortfolioListRow;
